import { render, staticRenderFns } from "./productionDetails.vue?vue&type=template&id=8a9bc554&scoped=true"
import script from "./productionDetails.vue?vue&type=script&lang=js"
export * from "./productionDetails.vue?vue&type=script&lang=js"
import style0 from "./productionDetails.vue?vue&type=style&index=0&id=8a9bc554&prod&lang=scss"
import style1 from "./productionDetails.vue?vue&type=style&index=1&id=8a9bc554&prod&scoped=true&lang=css"
import style2 from "./productionDetails.vue?vue&type=style&index=2&id=8a9bc554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9bc554",
  null
  
)

export default component.exports